module.exports = __webpack_public_path__ + "image/article_pro_main_logo8.png";